import { Injectable, OnDestroy, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavigationItemChild } from '../interfaces/nav-item.interfaces';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService implements OnDestroy {
  private resizeSubscription!: Subscription;
  private hoverTimeout;
  private offSet: number;
  private detectResize = new BehaviorSubject<number>(0);
  private element: HTMLElement;
  private stuckMenu = signal(false);
  private stuckMenuItem = signal('');
  offSetvalue$ = this.detectResize.asObservable();

  menu: Record<string, NavigationItemChild[]>;
  renderedChildren = signal<NavigationItemChild[]>([]);
  currentMenuItem = signal<string>('none');

  constructor(router: Router) {
    this.onResize();
    router.events.subscribe((routerEvent) => {
      if (routerEvent instanceof NavigationEnd) {
        for (const key in this.menu) {
          const lowerCaseKey = key.toLowerCase();
          if (router.url.replaceAll('-', ' ').toLowerCase().includes(lowerCaseKey)) {
            this.setSubNavPosition(document.getElementById(lowerCaseKey));
            this.stickMenuItem(key);
            break;
          }
        }
      }
    });
  }

  public stickMenuItem(topMenuItem: string) {
    this.currentMenuItem.set(topMenuItem);
    this.setChildrenToRender(topMenuItem);
    this.stuckMenuItem.set(topMenuItem);
    this.stuckMenu.set(true);
  }

  setMenu(menu: Record<string, NavigationItemChild[]>) {
    this.menu = menu;
  }

  onHoverEnter(topMenuItem: string) {
    clearTimeout(this.hoverTimeout);
    if (this.currentMenuItem() !== topMenuItem) {
      this.currentMenuItem.set(topMenuItem);
      if (this.menu) {
        this.setChildrenToRender(topMenuItem);
      }
    }
  }

  private setChildrenToRender(topMenuItem: string) {
    if (this.menu) {
      this.renderedChildren.set(
        this.menu[topMenuItem]?.map((tmi) => {
          tmi.parent = topMenuItem;
          return tmi;
        })
      );
    }
  }
  onResize() {
    this.resizeSubscription = fromEvent(window, 'resize').subscribe(() => {
      this.setSubNavPosition(this.element);
    });
  }
  ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }
  setSubNavPosition(element: HTMLElement) {
    if (element) {
      this.element = element ?? this.element;
      const elementOffset = document.getElementsByClassName('mat-sidenav-content')[0].clientWidth - element.offsetLeft - element.offsetWidth;
      this.offSet =
        !Array.from(element.childNodes).some((e) => e.nodeName.toLowerCase().includes('icon')) && elementOffset ? elementOffset : this.offSet;
      this.detectResize.next(this.offSet);
    }
  }

  onHoverLeave() {
    this.hoverTimeout = setTimeout(() => {
      if (this.stuckMenu()) {
        this.currentMenuItem.set(this.stuckMenuItem());
        const stuckMenu = this.currentMenuItem[Object.getOwnPropertySymbols(this.currentMenuItem)[0]];
        this.setSubNavPosition(document.getElementById(stuckMenu.value.toLowerCase()));
        this.setChildrenToRender(stuckMenu.value);
      } else {
        this.renderedChildren.set([]);
        this.currentMenuItem.set('none');
      }
    }, 1000);
  }
}
